import { render, staticRenderFns } from "./FlagstartOutline.vue?vue&type=template&id=1660cb4c&"
import script from "./FlagstartOutline.vue?vue&type=script&lang=ts&"
export * from "./FlagstartOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports